import {eq} from '@shared/helpers/lang'

import {FDS_AUTH_LEVEL, FDSAuthLevel} from '@web/core/constants'

/** ars 인증인 경우 apply api에 sessionKey를 전달해야 함. */
export const getSessionKeyForFdsAuth = (partialFdsState: {
    level?: Maybe<FDSAuthLevel>
    sessionKey?: Maybe<string>
}): Maybe<{arsSessionKey?: string; threeDsSessionKey?: string}> => {
    const {level, sessionKey} = partialFdsState

    if (eq(level, FDS_AUTH_LEVEL.ARS) && sessionKey) {
        return {arsSessionKey: sessionKey}
    } else if (eq(level, FDS_AUTH_LEVEL.THREE_DS) && sessionKey) {
        return {threeDsSessionKey: sessionKey}
    }

    return null
}
